import { useBoolean } from 'react-use'
import { FilterItemSpan } from '../../base'
import IconMoreFilter from '@icon/home/filter.svg'
import FullPopup from '@component/fullPopup'
import AppendRoot from '@component/appendRoot'
import { useCallback, useMemo } from 'react'
import { compact, filter, get, isBoolean, size, split } from 'lodash-es'
import MoreFilterContent from './content'
import useHouseSearchContext from '../../../context'
import useParamsToFilter from '../../useParams2filter'
import getHouseRoute from '@plugin/searchRoute/modules/house'

export default function MoreFilter() {
  const { state, filterMeta } = useHouseSearchContext()
  const [, query] = useParamsToFilter({ state, filterMeta })

  // 是否显示Popup
  const [open, togglOpen] = useBoolean(false)
  const displayPopup = useCallback(visiable => {
    togglOpen(isBoolean(visiable) ? visiable : undefined)
  }, [togglOpen])
  const [isActive, activeLen] = useMemo(() => {
    const houseRoute = getHouseRoute()
    houseRoute.fromSlug(state.slug)
    const { bedroom, bathroom, carspaces } = houseRoute
    const filterStr = get(state, 'searchParams.filter')

    const items = compact([
      size(bedroom) > 0,
      size(bathroom) > 0,
      size(carspaces) > 0,
      size(houseRoute['property-type']) > 0,
      size(houseRoute.categories) > 0,
      size(houseRoute.landarea) > 0,
      size(houseRoute.floorarea) > 0,
      houseRoute['price-from'] || houseRoute['price-to'],
      size(houseRoute['living-options']) > 0
    ])
    if (filterStr) {
      const d = filter(split(filterStr, '_'), (_, i) => i % 2 === 0)
      items.push(...d)
    }

    return [
      size(items) > 0 || open,
      size(items)
    ]
  }, [open, state])

  return (
    <>
      <div className='flex-1'>
        <FilterItemSpan active={isActive} onClick={displayPopup} showArrow={false}>
          <IconMoreFilter width={16} height={16} className='mr-6 align-middle w-18 h-18 fill-font stroke-font'></IconMoreFilter>
          <span className='hidden lg:inline-block'>More filters</span>
          <span className='lg:hidden align-middle'>Select Filters</span>
          {activeLen ? <span className='bg-secondary text-white min-w-[18px] h-18 md:min-w-[20px] md:h-20 rounded-half inline-flex items-center justify-center text-xs leading-none ml-2 md:ml-6'>{activeLen}</span> : ''}
        </FilterItemSpan>
      </div>
      <AppendRoot>
        <FullPopup show={open} smCenter mobileFull maskCloseable onClose={displayPopup} contentClassName='!bg-transparent'>
          <div className='w-screen h-fill-screen bg-white sm:max-w-[94vw] sm:w-[800px] sm:h-auto sm:rounded-sm'>
            {query && <MoreFilterContent onClose={displayPopup}></MoreFilterContent>}
          </div>
        </FullPopup>
      </AppendRoot>
    </>
  )
}
